import { useEffect, useRef, useState } from "react"
import { FiCheck, FiX } from "react-icons/fi"

export const MultiSelectFloatingLabel = ({ label, value = [], onChange, options, placeholder }) => {
  const containerRef = useRef(null)
  const [isOpen, setIsOpen] = useState(false)
  const [search, setSearch] = useState('')

  const filteredOptions = search
    ? options.filter((option) =>
        option.label.toLowerCase().includes(search.toLowerCase())
      )
    : options

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false)
        setSearch('')
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const toggleOption = (optionValue) => {
    if (value.includes(optionValue)) {
      onChange(value.filter((v) => v !== optionValue))
    } else {
      onChange([...value, optionValue])
    }
  }

  const removeTag = (optionValue, e) => {
    e.stopPropagation()
    onChange(value.filter((v) => v !== optionValue))
  }

  const selectedOptions = options.filter((option) => value.includes(option.value))

  return (
    <div ref={containerRef} className='relative'>
      <label className='block text-xs text-gray-500 mb-1'>{label}</label>
      <div
        onClick={() => setIsOpen(true)}
        className='min-h-[42px] flex flex-wrap items-center gap-1.5 border-0 border-b-2 border-gray-300 focus-within:border-everglade-600 px-0 py-1.5 cursor-text'
      >
        {selectedOptions.map((option) => (
          <span
            key={option.value}
            className='flex items-center gap-1 bg-everglade-50 text-everglade-800 text-xs font-medium pl-2 pr-1 py-1 rounded-full'
          >
            {option.label}
            <button
              type='button'
              onClick={(e) => removeTag(option.value, e)}
              className='text-everglade-500 hover:text-everglade-800 rounded-full hover:bg-everglade-100'
            >
              <FiX size={12} />
            </button>
          </span>
        ))}
        <input
          type='text'
          value={search}
          onChange={(e) => {
            setSearch(e.target.value)
            setIsOpen(true)
          }}
          onFocus={() => setIsOpen(true)}
          placeholder={selectedOptions.length === 0 ? placeholder  : ''}
          className='flex-1 min-w-[80px] text-sm border-0 outline-none bg-transparent p-0 focus:ring-0'
        />
      </div>

      {isOpen && (
        <ul className='absolute left-0 top-[100%] z-50 mt-1 max-h-56 w-full overflow-y-auto rounded-md border border-gray-200 bg-white shadow-lg'>
          {filteredOptions.length === 0 ? (
            <li className='px-3 py-2 text-sm text-gray-400'>No matches found</li>
          ) : (
            filteredOptions.map((option) => {
              const isSelected = value.includes(option.value)
              return (
                <li
                  key={option.value}
                  onMouseDown={(e) => {
                    e.preventDefault()
                    toggleOption(option.value)
                  }}
                  className={`px-3 py-2 text-sm cursor-pointer flex items-center justify-between ${
                    isSelected
                      ? 'bg-everglade-600 text-white'
                      : 'text-gray-700 hover:bg-everglade-50'
                  }`}
                >
                  {option.label}
                  {isSelected && <FiCheck size={14} />}
                </li>
              )
            })
          )}
        </ul>
      )}
    </div>
  )
}
